import { appConfig } from "@quest/appConfig";
import schoolAxiosInstance from "@quest/school-axios";

function useSubscribe() {
  function urlBase64ToUint8Array(base64String: string) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
  }

  const subscribeUserToPush = async () => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      console.error("Push notifications not supported");
      return;
    }

    try {
      const registration = await navigator.serviceWorker.ready;

      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(appConfig.publicVapidKey),
      });

      const parsedData = {
        endpoint: subscription.endpoint,
        auth_key: subscription.toJSON().keys?.auth,
        p256dh_key: subscription.toJSON().keys?.p256dh,
      };

      await schoolAxiosInstance.post("/notifications/subscription", parsedData);
    } catch (err) {
      console.error("Push subscription error:", err);
    }
  };
  return { subscribeUserToPush };
}

export { useSubscribe };
